import { color, px } from 'csx';
import * as React from 'react';
import { classes, cssRaw, style, TypeStyle } from 'typestyle';
import { colorGunmetal, colorWhite, rebrand } from '../../../theme/color';
import { CheckCircle } from './icons/CheckCircle';
import { VariationBox } from './icons/VariationBox';

const styles = {
  container: style({
    position: 'relative',
    width: px(20),
    height: px(20),
  }),
  number: style({
    position: 'absolute',
    top: '50%',
    left: 'calc(50% - 1px)',
    transform: 'translate(-50%, -50%)',
    fontSize: '10px',
    fontWeight: 700,
    color: colorGunmetal.toHexString(),
  }),
};

type VariationsProps = {
  number: number;
};

export const Variations: React.SFC<VariationsProps> = ({ number }) => (
  <div className={styles.container}>
    <VariationBox role="img" aria-label={`This track has ${number} variations`} size={20} />
    <span className={styles.number}>{number}</span>
  </div>
);
